module.exports = __webpack_public_path__ + "static/media/logo-white-2.18783fc9.svg";